import store from "@/store";

function setSelectedGroup(key){
  let selectedGroup = store.getters.groups[key];
	store.dispatch("SET_SELECTED_GROUP_KEY", key);
	store.dispatch("SET_SELECTED_GROUP", selectedGroup);
	store.dispatch("SET_SELECTED_GROUP_MEMBERS", selectedGroup.members);
}

function setSelectedMember(key){
  let membershipData = store.getters.memberships[key];
  if(membershipData){
    store.dispatch("SET_SELECTED_MEMBER_KEY", key);
    store.dispatch("SET_SELECTED_MEMBER", membershipData.email);
    store.dispatch("SET_SELECTED_MEMBERSHIPS", membershipData.memberships);
  }
}

export {
  setSelectedGroup,
  setSelectedMember
}


// WEBPACK FOOTER //
// ./src/vue-service-groups.js